interface LoaderProps {
    style?: React.CSSProperties
}

const Loader = ({style}: LoaderProps) => {
    return (
        <div style={style} className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
}

export default Loader;